import { render } from "./AndroidA.vue?vue&type=template&id=40633463&scoped=true"
import script from "./AndroidA.vue?vue&type=script&lang=js"
export * from "./AndroidA.vue?vue&type=script&lang=js"

import "./AndroidA.vue?vue&type=style&index=0&id=40633463&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40633463"]])

export default __exports__